import React from 'react';

function RSVPForm({ formData, onChange, onSubmit, onIntolleranzaChange, onIntolleranzaPlusOneChange, onPreferenzaAlimentareChange, onPreferenzaAlimentarePlusOneChange, loading, error }) {
    const intolleranzeOptions = [
        { value: 'glutine', label: 'Glutine / Celiachia' },
        { value: 'lattosio', label: 'Intolleranza al Lattosio' },
        { value: 'frutta-secca', label: 'Frutta a guscio' },
        { value: 'pesce', label: 'Pesce' },
        { value: 'crostacei', label: 'Crostacei' },
        { value: 'molluschi', label: 'Molluschi' },
        { value: 'uova', label: 'Uova' },
        { value: 'latteDerivati', label: 'Latte e Derivati' },
        { value: 'altro', label: 'Altro' }
    ];

    const preferenzeAlimentariOptions = [
        { value: 'vegetariano', label: 'Vegetariano' },
        { value: 'vegano', label: 'Vegano' },
        { value: 'altro', label: 'Altro regime alimentare' }
    ];

    const isFormValid = () => {
        return !loading &&
            formData.nome &&
            formData.cognome &&
            (!formData.plusOne || (formData.nomePlusOne && formData.cognomePlusOne)) &&
            (!formData.intolleranze || formData.tipoIntolleranza.length > 0) &&
            (!formData.tipoIntolleranza.includes('altro') || formData.altroIntolleranza) &&
            (!formData.intolleranzePlusOne || formData.tipoIntolleranzaPlusOne.length > 0) &&
            (!formData.tipoIntolleranzaPlusOne.includes('altro') || formData.altroIntolleranzaPlusOne) &&
            (!formData.preferenzeAlimentari || formData.tipoPreferenzaAlimentare.length > 0) &&
            (!formData.tipoPreferenzaAlimentare.includes('altro') || formData.altroPreferenzaAlimentare) &&
            (!formData.preferenzeAlimentariPlusOne || formData.tipoPreferenzaAlimentarePlusOne.length > 0) &&
            (!formData.tipoPreferenzaAlimentarePlusOne.includes('altro') || formData.altroPreferenzaAlimentarePlusOne);
    };

    return (
        <form onSubmit={onSubmit} className="rsvp-form">
            <h2 className="form-title">Conferma la tua Partecipazione</h2>
            <p className="form-subtitle">Si prega di dare conferma entro l' <b>08/11/2026</b></p>

            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
                <label htmlFor="nome">Nome</label>
                <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={onChange}
                    required
                    placeholder="Il tuo nome"
                />
            </div>

            <div className="form-group">
                <label htmlFor="cognome">Cognome</label>
                <input
                    type="text"
                    id="cognome"
                    name="cognome"
                    value={formData.cognome}
                    onChange={onChange}
                    required
                    placeholder="Il tuo cognome"
                />
            </div>

            <div className="form-group checkbox-group">
                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        name="plusOne"
                        checked={formData.plusOne}
                        onChange={onChange}
                    />
                    <span style={{ marginLeft: '8px' }}>sarò accompagnato/a</span>
                </label>
            </div>

            {formData.plusOne && (
                <div className="plusone-section">
                    <div className="form-group">
                        <label htmlFor="nomePlusOne">Nome accompagnatore</label>
                        <input
                            type="text"
                            id="nomePlusOne"
                            name="nomePlusOne"
                            value={formData.nomePlusOne}
                            onChange={onChange}
                            required
                            placeholder="Nome del tuo accompagnatore"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="cognomePlusOne">Cognome accompagnatore</label>
                        <input
                            type="text"
                            id="cognomePlusOne"
                            name="cognomePlusOne"
                            value={formData.cognomePlusOne}
                            onChange={onChange}
                            required
                            placeholder="Cognome del tuo accompagnatore"
                        />
                    </div>

                    <div className="form-group checkbox-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="intolleranzePlusOne"
                                checked={formData.intolleranzePlusOne}
                                onChange={onChange}
                            />
                            <span style={{ marginLeft: '8px' }}>Intolleranze / Allergie</span>
                        </label>
                    </div>

                    {formData.intolleranzePlusOne && (
                        <div className="form-group">
                            <label>Seleziona le intolleranze / allergie del +1</label>
                            <div className="intolleranze-list">
                                {intolleranzeOptions.map(item => (
                                    <label key={item.value} className="intolleranza-item">
                                        <input
                                            type="checkbox"
                                            checked={formData.tipoIntolleranzaPlusOne.includes(item.value)}
                                            onChange={() => onIntolleranzaPlusOneChange(item.value)}
                                        />
                                        <span style={{ marginLeft: '8px' }}>{item.label}</span>
                                    </label>
                                ))}
                            </div>
                            {formData.tipoIntolleranzaPlusOne.includes('altro') && (
                                <div className="form-group" style={{ marginTop: '15px' }}>
                                    <label htmlFor="altroIntolleranzaPlusOne">Specifica l'intolleranza del +1</label>
                                    <input
                                        type="text"
                                        id="altroIntolleranzaPlusOne"
                                        name="altroIntolleranzaPlusOne"
                                        value={formData.altroIntolleranzaPlusOne}
                                        onChange={onChange}
                                        required
                                        placeholder="Indica a cosa è allergico"
                                    />
                                </div>
                            )}
                        </div>
                    )}

                    <div className="form-group checkbox-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="preferenzeAlimentariPlusOne"
                                checked={formData.preferenzeAlimentariPlusOne}
                                onChange={onChange}
                            />
                            <span style={{ marginLeft: '8px' }}>Preferenze alimentari</span>
                        </label>
                    </div>

                    {formData.preferenzeAlimentariPlusOne && (
                        <div className="form-group intolleranze">
                            <label>Seleziona le preferenze alimentari del +1</label>
                            <div className="intolleranze-list">
                                {preferenzeAlimentariOptions.map(item => (
                                    <label key={item.value} className="intolleranza-item">
                                        <input
                                            type="checkbox"
                                            checked={formData.tipoPreferenzaAlimentarePlusOne.includes(item.value)}
                                            onChange={() => onPreferenzaAlimentarePlusOneChange(item.value)}
                                        />
                                        <span style={{ marginLeft: '8px' }}>{item.label}</span>
                                    </label>
                                ))}
                            </div>
                            {formData.tipoPreferenzaAlimentarePlusOne.includes('altro') && (
                                <div className="form-group" style={{ marginTop: '15px' }}>
                                    <label htmlFor="altroPreferenzaAlimentarePlusOne">Specifica il regime alimentare del +1</label>
                                    <input
                                        type="text"
                                        id="altroPreferenzaAlimentarePlusOne"
                                        name="altroPreferenzaAlimentarePlusOne"
                                        value={formData.altroPreferenzaAlimentarePlusOne}
                                        onChange={onChange}
                                        required
                                        placeholder="Descrivi il regime alimentare"
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}

            <div className="form-group checkbox-group">
                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        name="intolleranze"
                        checked={formData.intolleranze}
                        onChange={onChange}
                    />
                    <span style={{ marginLeft: '8px' }}>Intolleranze / Allergie</span>
                </label>
            </div>

            {formData.intolleranze && (
                <div className="form-group intolleranze">
                    <label>Seleziona le tue intolleranze / Allergie</label>
                    <div className="intolleranze-list">
                        {intolleranzeOptions.map(item => (
                            <label key={item.value} className="intolleranza-item">
                                <input
                                    type="checkbox"
                                    checked={formData.tipoIntolleranza.includes(item.value)}
                                    onChange={() => onIntolleranzaChange(item.value)}
                                />
                                <span style={{ marginLeft: '8px' }}>{item.label}</span>
                            </label>
                        ))}
                    </div>
                    {formData.tipoIntolleranza.includes('altro') && (
                        <div className="form-group" style={{ marginTop: '15px' }}>
                            <label htmlFor="altroIntolleranza">Specifica l'intolleranza</label>
                            <input
                                type="text"
                                id="altroIntolleranza"
                                name="altroIntolleranza"
                                value={formData.altroIntolleranza}
                                onChange={onChange}
                                required
                                placeholder="Indica a cosa sei allergico"
                            />
                        </div>
                    )}
                </div>
            )}

            <div className="form-group checkbox-group">
                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        name="preferenzeAlimentari"
                        checked={formData.preferenzeAlimentari}
                        onChange={onChange}
                    />
                    <span style={{ marginLeft: '8px' }}>Preferenze alimentari</span>
                </label>
            </div>

            {formData.preferenzeAlimentari && (
                <div className="form-group intolleranze">
                    <label>Seleziona le tue preferenze alimentari</label>
                    <div className="intolleranze-list">
                        {preferenzeAlimentariOptions.map(item => (
                            <label key={item.value} className="intolleranza-item">
                                <input
                                    type="checkbox"
                                    checked={formData.tipoPreferenzaAlimentare.includes(item.value)}
                                    onChange={() => onPreferenzaAlimentareChange(item.value)}
                                />
                                <span style={{ marginLeft: '8px' }}>{item.label}</span>
                            </label>
                        ))}
                    </div>
                    {formData.tipoPreferenzaAlimentare.includes('altro') && (
                        <div className="form-group" style={{ marginTop: '15px' }}>
                            <label htmlFor="altroPreferenzaAlimentare">Specifica il tuo regime alimentare</label>
                            <input
                                type="text"
                                id="altroPreferenzaAlimentare"
                                name="altroPreferenzaAlimentare"
                                value={formData.altroPreferenzaAlimentare}
                                onChange={onChange}
                                required
                                placeholder="Descrivi il tuo regime alimentare"
                            />
                        </div>
                    )}
                </div>
            )}

            {Date.now() > new Date('2026-11-08T23:59:59') ? (
                <button type="submit" className="submit-button" disabled={true}>
                    Il periodo per confermare la partecipazione è scaduto.
                </button>
            ) : (
                <button type="submit" className="submit-button" disabled={!isFormValid()}>
                    {loading ? 'Conferma in corso...' : 'Conferma Partecipazione'}
                </button>
            )}
        </form>
    );
}

export default RSVPForm;
